import React from "react";

export default function Bar({ label, value, max = 25 }) {
  const safeMax = max > 0 ? max : 25;
  const pct = Math.min(100, Math.max(0, Math.round((value / safeMax) * 100)));
  const isZero = pct === 0;
  return (
    <div className="ss-bar">
      <div className="ss-bar__row">
        <span className="ss-bar__label">{label}</span>
        <span className="ss-bar__value">{value}/{safeMax}</span>
      </div>
      <div className="ss-bar__track">
        <div
          className={`ss-bar__fill ${isZero ? "is-zero" : ""}`}
          style={{ width: pct + "%" }}
        ></div>
      </div>
    </div>
  );
}
